/**
 * Common Store
 * 공통 Store
 *
 * @since 2018-03-13
 * @author kdydesign.kim
 * @수정이력
 * - 2018-04-05 ms1124.kim : isChanged 상태값 추가
 * - 2019-04-04 devp014 (Nanhyoung.ro) : isDownload 상태값 추가
 */

// utils
import {formatDate, getStepDate} from '../../utils/date'
import {i18n} from '../../plugins/i18n'

let agentTimer = null,
  agentIntervalTimer = void 0

const initSyncInfo = () => {
  return {
    sync_status: 0, // 0: success, 1: fail, 2: pending, 3: progress, 4: disabled
    sync_total: 0,
    sync_summary: {
      success: 0,
      fail: 0,
      pending: 0,
      progress: 0
    }
  }
}

function timer (state) {
  agentTimer = setTimeout(() => {
    if (agentTimer) {
      clearTimeout(agentTimer)
    }
    state.agentTime = getStepDate(state.agentTime, 'YYYY-MM-DD HH:mm:ss', 1, 'seconds')
    timer(state)
  }, 1000)
}

export const state = () => ({
  authUser: void 0,
  isChanged: false,
  isShowNav: true,
  isContentsAreaNoPadding: false,
  isWriteable: false,
  isDownloaded: false,
  components: {
    alertDialog: null,
    loadingDialog: null,
    reloginDialog: null,
    duplicateConfirmDialog: null
  },
  uiData: null,
  agentTime: null,
  agentTimeVeVolume: {},
  haMembers: [],
  geMembers: [], // TAMS
  newWindows: {},
  apiPrefix: '',
  backUp: false,
  // TAMS
  preventLogoutAfterTimer: false,
  alarmUpdateTime: '',
  ticketEventUpdateTime: '',
  alarmInfo: void 0,
  ticketEventInfo: void 0,
  syncInfo: initSyncInfo(),
  isIdle: 0, // 0: 사용중, 1: 유휴 상태,

  eventCodes: [], // 이벤트 코드
  preventLock: false,
  totalMenu: [] // TAMS, 전체 메뉴 (계정 권한 구분 없이)
})

export const mutations = {
  // 변경 여부 flag 설정
  setIsChanged (state, changed = false) {
    state.isChanged = changed
  },
  /**
   * 이름: setShowGnbNav
   * 설명: GNB 네비게이선 영역이 숨겨져있는지 펼쳐져있는지에 대한 값을 설정한다.
   * @param state
   * @param isShow
   */
  setShowGnbNav (state, isShow) {
    state.isShowNav = isShow
  },
  // 19.04.04 파일 다운로드 진행중 여부 변경
  setIsDownloaded (state, changed = false) {
    state.isDownloaded = changed
  },

  // 읽기/쓰기 권한 여부
  isWriteable (state, user) {
    if (user.level > 1) {
      state.isWriteable = true
    }
  },

  // global 컴포넌트 설정
  setGlobalComponent (state, components) {
    state.components = components
  },

  // ui-data 조회
  getUIData (state, data) {
    state.uiData = data
    state.haMembers = _.get(data, ['ha', 'mmbr'], [])
    state.authUser = data.user
    // TAMS
    state.geMembers = _.get(data, ['ge'], [])
  },

  // 오로지 세션만료 로그아웃 시 사용
  clearAgentTimeTimer (state) {
    state.preventLogoutAfterTimer = true

    if (typeof agentTimer !== 'undefined') {
      clearTimeout(agentTimer)
      agentTimer = void 0
    }
    if (typeof agentIntervalTimer !== 'undefined') {
      clearInterval(agentIntervalTimer)
      agentIntervalTimer = void 0
    }
  },

  // 장비 시간 타이머 등록
  getAgentTime (state, data) {
    if (typeof agentTimer !== 'undefined') {
      clearTimeout(agentTimer)
      agentTimer = void 0
    }
    state.agentTime = formatDate(data.current_time, 'YYYY-MM-DD HH:mm:ss')
    // ve모드 일때 current-time에 ve_volume 값 조회
    if (!_.isEmpty(data.ve_volume)) {
      state.agentTimeVeVolume = data.ve_volume
    }
    // 자동 세션 아웃 시간 만료 후 timer 호출 방지
    if (!state.preventLogoutAfterTimer) {
      timer(state)
    } else {
      if (typeof agentTimer !== 'undefined') {
        clearTimeout(agentTimer)
        agentTimer = void 0
      }
    }
  },

  // 유휴시간 동기화 뮤테이션
  setIdleTimeData (state, idleOptions) {
    // TAMS
    state.uiData.admin_general['system.admin.account_idle_lock_t_num'] = idleOptions.account_idle_lock_t_num
    state.uiData.admin_general['system.admin.account_idle_logout_t_num'] = idleOptions.account_idle_logout_t_num
  },

  // 새창으로 연 윈도우 객체를 초기화한다.
  initNewWindows (state) {
    // 윈도우 객체 모두 종료
    for (const key in state.newWindows) {
      if (typeof state.newWindows[key] !== 'undefined') {
        state.newWindows[key].close()
        delete state.newWindows[key]
      }
    }

    // 스토어 state 초기화
    state.newWindows = {}
  },

  delClosedWindows (state) {
    // close된 새창 데이터 제거
    for (const key in state.newWindows) {
      if (state.newWindows[key] && state.newWindows[key].closed) {
        delete state.newWindows[key]
      }
    }
  },

  setApiPrefix (state, uuid) {
    state.apiPrefix = uuid
  },

  setAlarmInfo (state, payload) {
    state.alarmUpdateTime = payload.update_time
    state.alarmInfo = payload
  },
  setSyncInfo (state, payload) {
    // syncInfo: {
    //   sync_status: 0, // 0: success, 1: fail, 2: pending, 3: progress, 4: disabled
    //   sync_total: 0,
    //   sync_summary: {
    //     success: 0,
    //     fail: 0,
    //     pending: 0,
    //     progress: 0
    //   }
    // },
    state.syncInfo = payload
  },

  setTicketEventInfo (state, payload) {
    state.ticketEventInfo = payload
  },

  initAlarmInfo (state) {
    state.alarmUpdateTime = ''
    state.alarmInfo = void 0
  },

  // 유휴 상태값 업데이트
  setIsIdle (state, isIdle) {
    state.isIdle = isIdle
  },

  setEventCodes (state, payload) {
    state.eventCodes = payload
  },

  setPreventLock (state, isPreventLock) {
    state.preventLock = isPreventLock
  },
  setTotalMenu (state, data) {
    state.totalMenu = data
  },
  clearTotalMenu (state) {
    state.totalMenu = []
  },
  setIsContentsAreaNoPadding (state, data) {
    state.isContentsAreaNoPadding = data
  }
}

export const actions = {
  // 데이터 변경 여부
  setIsChanged ({state, commit}, changed) {
    commit('setIsChanged', changed)
  },
  setIsDownloaded ({state, commit}, changed) {
    commit('setIsDownloaded', changed)
  },

  // UI-Data 조회
  async getUIData ({state, commit, dispatch, rootState}) {
    const uri = '/api/au/ui-data'
    const {code, result} = await this.$axios.$get(uri, {loading: true, ignoreHaPrefix: true})

    function notShowMenu1CC (menu1) {
      if (menu1.code === 100000) _.forEach(menu1.children, notShowMenu2CC)
    }
    function notShowMenu2CC (menu2) {
      if (menu2.code === 120000) menu2.children = _.filter(menu2.children, menu3 => menu3.code !== 120601)
    }

    if (code === 'ok') {
      // TAMS 1.3.0 CC 임시 대응
      const ccFlag = _.get(result, ['system', 'cc_flag'], 0)
      const veType = _.get(result, ['system', 've_type'], 0)
      const ceResult = result

      if (ccFlag === 1) _.forEach(ceResult.menu, notShowMenu1CC)

      commit('getUIData', result)
      commit('common/navigation/setMenu', {
        menu: result.menu,
        user: result.user
      }, { root: true })
      commit('common/navigation/setClientMenu', result.clientMenu, { root: true })

      // 장비 실제시간 요청
      const resAgentTime = await dispatch('getAgentTime')

      // 만약에 장비시간을 가져오지 못했을경우 -> 어떻게 처리할 것인지 확인 후 진행
      if (!resAgentTime) {
        this.$log('[Common api error] : Failed to get equipment time.')
      }

      // 1분 주기로 장비시간 요청
      setInterval(() => {
        if (veType > 0) {
          // code 값 -1, 0, 5, 999일 때 무시
          const veCode = state.agentTimeVeVolume.code
          // 라이선스 최초 등록일 때는 경고 메시지 띄어줄 필요없음
          const isMenuCond = ceResult.menu.length > 1
          if ([isMenuCond, veCode].every(code => code === 1)) {
            rootState.common.common.components.alertDialog.show(i18n.t('msg.volume_license_message_1_expired'), 'error')
          }
          if ([isMenuCond, veCode].every(code => code === 2)) {
            rootState.common.common.components.alertDialog.show(i18n.t('msg.volume_license_message_2_diff'), 'error')
          }
          if ([isMenuCond, veCode].every(code => code === 3)) {
            rootState.common.common.components.alertDialog.show(i18n.t('msg.volume_license_message_3_notexistVolume'), 'error')
          }
          if ([isMenuCond, veCode].every(code => code === 4)) {
            rootState.common.common.components.alertDialog.show(i18n.t('msg.volume_license_message_4_maxexceedVolume'), 'error')
          }
        }
        // 자동 세션 아웃 시간 만료 후 timer 호출 방지
        if (!state.preventLogoutAfterTimer) {
          dispatch('getAgentTime')
        } else {
          if (typeof agentIntervalTimer !== 'undefined') {
            clearInterval(agentIntervalTimer)
            agentIntervalTimer = void 0
          }
        }
      }, 20000) // TAMS: 서버 간 세션 체크 (60s -> 20s)
    }
  },

  // 장비 시간 조회
  async getAgentTime ({state, commit}) {
    try {
      const res = await this.$axios.$get('/api/co/current-time', {
        params: {
          isIdle: state.isIdle,
          timestamp: new Date().getTime()
        },
        loading: false,
        ignoreHaPrefix: true
      })

      if (res.code === 'ok') {
        commit('getAgentTime', res.result)

        if (state.preventLock === false || Number(state.uiData.system.cc_flag) === 1) {
          commit('setIsIdle', 1) // 유휴 상태로 업데이트
        } else {
          commit('setIsIdle', 0) // 로그아웃 금지 상태일 경우 사용 상태 유지.
        }

        return true
      }
    } catch (e) {
      this.$log('[Common Store GUI Error (getAgentTime)]', e)
    }

    return false
  },
  // 적용
  async agentApply ({state, commit, dispatch}, {prefix, url}) {
    await this.$axios.$put(`/api/${prefix}/${url}`, null, {applyMsg: true})

    dispatch('common/common/setIsChanged', false, {root: true})
  },
  // 취소
  async agentCancel ({state, commit, dispatch}, {prefix, url}) {
    await this.$axios.$put(`/api/${prefix}/${url}`, null, {cancelMsg: true})

    dispatch('common/common/setIsChanged', false, {root: true})
  },

  async getAlarmInfo ({state, commit}) {
    const updateTime = state.alarmUpdateTime.length > 0 ? state.alarmUpdateTime : 'None'
    const api = `/api/da/dashboard/alarm/${updateTime}`
    const { code, result } = await this.$axios.$get(api, {
      loading: false,
      successAlert: false,
      ignoreHaPrefix: true
    })

    if (code === 'ok') {
      result.event_list.sort((a, b) => b.level - a.level)
      commit('setAlarmInfo', result)
    }
  },

  async getSyncStatus ({state, commit, rootState}) {
    let res = { code: 'ok', result: {} }
    try {
      res = await this.$axios.$get('/api/sm/sync/menu', {
        loading: false,
        successAlert: false,
        ignoreHaPrefix: true
      })

      const syncInfo = initSyncInfo()
      if (res.code !== 'ok') return res
      syncInfo.sync_total = _.size(res.result)

      if (syncInfo.sync_total > 0) {
        _.each(res.result, item => {
          //   success: 0,
          //   fail: 0,
          //   pending: 0,
          //   progress: 0
          if (item.percent === 100) { // complete
            syncInfo.sync_summary.success++
          } else if (item.fail > 0) { // fail
            syncInfo.sync_summary.fail++
          } else if ((item.success + item.progress) > 0) { // in progress
            syncInfo.sync_summary.progress++
          } else if ((item.success === 0) && (item.progress > 0)) { // start
            syncInfo.sync_summary.progress++
          } else { // wait
            syncInfo.sync_summary.pending++
          }
        })

        // 0: success, 1: fail, 2: pending, 3: progress, 4: disabled
        if (syncInfo.sync_summary.progress > 0) {
          syncInfo.sync_status = 3
        } else if (syncInfo.sync_summary.pending > 0) {
          syncInfo.sync_status = 2
        } else if (syncInfo.sync_summary.success === syncInfo.sync_total) {
          syncInfo.sync_status = 0
        } else {
          syncInfo.sync_status = 1
        }
      }

      if (!rootState.common.navigation.authSyncConfig) {
        commit('setSyncInfo', syncInfo)
        return
      }
      // 동기화 설정 메뉴 권한 존재 시
      const res2 = await this.$axios.$get('/api/sm/sync/config', { loading: false, successAlert: false, ignoreHaPrefix: true })
      if (res2.code === 'ok') {
        const syncSettings = _.find(res2.result.sync_config, row => row.key === 'sync.settings.enable_yn')
        const syncEnable = syncSettings.val
        if (Number(syncEnable) !== 1) syncInfo.sync_status = 4 // disable
      }
      commit('setSyncInfo', syncInfo)
    } catch (e) {
      res.code = 'nok'
      res.msg = e.message
    }
    return res
  },

  // 이벤트 코드
  async loadEventCode ({state, commit}) {
    const api = '/api/lr/prism/log/message/info/type'
    try {
      const {code, result} = await this.$axios.$get(api, {
        loading: false,
        successAlert: false,
        ignoreHaPrefix: true
      })
      if (code === 'ok') {
        commit('setEventCodes', result.event)
      }
    } catch (e) {
      this.$log('[Error loadEventCode]: ', e)
      commit('setEventCodes', [])
    }
  },
  async getTotalMenu ({state, commit}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(`/api/sm/menu`, {
        params: {
          admin_list_yn: 1
        }
      })
      if (res.code === 'ok') {
        commit('setTotalMenu', res.result.menu)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },

  async getTicketEventInfo ({state, commit}) { // Ticket Event 정보
    const api = `/api/lr/ticket/summary`
    const { code, result } = await this.$axios.$get(api, {
      loading: false,
      successAlert: false,
      ignoreHaPrefix: true
    })
    if (code === 'ok') {
      commit('setTicketEventInfo', result)
    }
  },

  async geTamsCheckIn ({state}, {geMember, checkMenuCode}) {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      const api = `/GE:${geMember.device_mmbr_uuid}/api/sm/tams-chkin`

      const tamsInfo = state.uiData.system.tams_info[0]
      const usrInfo = state.uiData.user

      res = await this.$axios.$post(api, {
        tams_login_ip: tamsInfo.device_ip,
        tams_admin_login_name: usrInfo.login_id,
        tams_device_login_name: tamsInfo.device_uname,
        tams_chkin_menu: checkMenuCode
      }, { successAlert: false, applyMsg: false })
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }

    return res
  }
}

export const getters = {
  getUiData (state) {
    return state.uiData || null
  },
  isChanged (state) {
    return state.isChanged
  },
  isDownloaded (state) {
    return state.isDownloaded
  },
  getDeviceTime (state) {
    return state.agentTime
  },
  getSelectedHaUuid (state) {
    return state.selectedHaUuid
  },
  getPreventLock (state) {
    return state.preventLock
  }
}

export const strict = false
